import { apiResponse } from "@/shared/api/client";

/** 环境配置摘要（已由后端剔除 SECRET_KEY） */
export type EnvSummary = Record<string, unknown>;

export interface NotificationConf {
  name?: string | null;
  type?: string | null;
  enabled?: boolean | null;
  /** 仅展示密钥是否已配置，不回显明文 */
  has_config?: boolean;
  switchs?: unknown[];
  /** 原始 config 仅用于 has_config 判断，展示层勿渲染 */
  config?: Record<string, unknown> | null;
}

export function fetchEnv() {
  return apiResponse<EnvSummary>("/api/v1/system/env");
}

export function fetchUserGlobal() {
  return apiResponse<Record<string, unknown>>("/api/v1/system/global/user");
}

export async function fetchNotifications(): Promise<NotificationConf[]> {
  const data = await apiResponse<{ value?: NotificationConf[] }>(
    "/api/v1/system/setting/Notifications",
  );
  const list = data?.value;
  if (!Array.isArray(list)) return [];
  return list.map((n) => ({
    name: n.name,
    type: n.type,
    enabled: n.enabled,
    has_config: Boolean(n.config && Object.keys(n.config as object).length),
    switchs: n.switchs,
  }));
}

/**
 * 仅更新 enabled 开关。
 * 读回完整配置（含密钥字段）仅在内存中改 enabled 后写回，UI 永不渲染密钥。
 */
export async function setNotificationEnabled(
  name: string,
  enabled: boolean,
): Promise<void> {
  const data = await apiResponse<{ value?: Array<Record<string, unknown>> }>(
    "/api/v1/system/setting/Notifications",
  );
  const list = Array.isArray(data?.value)
    ? data.value.map((n) => ({ ...n }))
    : [];
  const idx = list.findIndex((n) => n.name === name);
  if (idx < 0) throw new Error("未找到该通知渠道");
  list[idx] = { ...list[idx], enabled };
  await apiResponse("/api/v1/system/setting/Notifications", {
    method: "POST",
    body: list,
  });
}

export function pingSystem() {
  return apiResponse("/api/v1/system/ping");
}

/** 白名单字段用于 UI 展示，避免整包 env 泄露噪音与敏感路径 */
export const ENV_DISPLAY_KEYS = [
  "VERSION",
  "FRONTEND_VERSION",
  "APP_DOMAIN",
  "HOST",
  "PORT",
  "RECOGNIZE_SOURCE",
  "SEARCH_SOURCE",
  "TMDB_API_DOMAIN",
  "PROXY_HOST",
  "DB_TYPE",
  "RUST_ACCEL_ENABLED",
  "RUST_ACCEL_AVAILABLE",
] as const;
